import React, { useState } from "react";
import { connect } from "react-redux";
import { Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { Card, Icon } from "tabler-react";
import "leaflet.smooth_marker_bouncing/leaflet.smoothmarkerbouncing";
// import "./smooth_marker_bouncing.js";
import "leaflet/dist/leaflet.css";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers.css";
import "leaflet.awesome-markers/dist/leaflet.awesome-markers";
import "./style.css";

import { helper } from "../../../../utils/helpers/helper";
import { mapActions } from "../../../../store/actions";

let iconName;

let newMarker;
function MapMarkerComponent(props) {
  let { filterData } = props;
  const [baseURL] = useState(
    process.env.REACT_APP_API_URL
      ? process.env.REACT_APP_API_URL
      : "https://wb-admin.nextgeni.us/"
  );

  return (
    filterData &&
    filterData.map((filteredRecord, idx) => {
      let icon = filteredRecord?.icon;
      iconName = new L.AwesomeMarkers.Icon({
        icon: icon?.category,
        prefix: icon?.icon,
        markerColor: filteredRecord?.color,
        iconColor: "black",
      });

      newMarker =
        !helper.isEmpty(filteredRecord.position[0]) &&
        !helper.isEmpty(filteredRecord.position[1]) ? (
          <Marker
            key={`marker-${idx}`}
            position={filteredRecord.position}
            icon={iconName}
            // ref={(input) => {bindMarker(input,idx)}}
          >
            <Popup id={"#" + filteredRecord.id} className="marker-popup">
              <Card>
                <Card.Status color={filteredRecord?.color} side />
                <Card.Body>
                  <p>
                    <>
                      {helper.get_user_role() === "admin" ? (
                        <a
                          className="float-right btn btn-link btn-sm"
                          rel="noopener noreferrer"
                          target="_blank"
                          href={
                            baseURL +
                            "map/incident/" +
                            filteredRecord.id +
                            "/change"
                          }
                        >
                          Edit <Icon prefix="fe" name="edit" />
                        </a>
                      ) : (
                        ""
                      )}
                    </>
                    {!helper.isEmpty(filteredRecord.date) ? (
                      <>
                        <strong>Date: </strong> {filteredRecord.date}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.accuracy) ? (
                      <>
                        <strong>Location Accuracy: </strong>{" "}
                        {filteredRecord.accuracy}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.district) ? (
                      <>
                        <strong>National District: </strong>{" "}
                        {filteredRecord.district}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.area) ? (
                      <>
                        <strong>Subdistrict / Town: </strong>{" "}
                        {filteredRecord.area}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.type) ? (
                      <>
                        <strong>Target: </strong> {filteredRecord.type}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.attack) ? (
                      <>
                        <strong>Attack Type: </strong> {filteredRecord.attack}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.attacker) ? (
                      <>
                        <strong>Attacker: </strong> {filteredRecord.attacker}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.casualties) ? (
                      <>
                        <strong>Casualties: </strong>{" "}
                        {filteredRecord.casualties}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.fatalities) ? (
                      <>
                        <strong>Fatalities: </strong>{" "}
                        {filteredRecord.fatalities}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.related_incident) ? (
                      <>
                        <strong>Related Incident: </strong>{" "}
                        {filteredRecord.related_incident}
                        <br />
                      </>
                    ) : (
                      ""
                    )}
                    {!helper.isEmpty(filteredRecord.detail) ? (
                      <strong>Incident Detail: </strong>
                    ) : (
                      ""
                    )}
                  </p>
                  {!helper.isEmpty(filteredRecord.detail)
                    ? filteredRecord.detail
                    : ""}
                </Card.Body>
                {!helper.isEmpty(filteredRecord.url) ? (
                  <Card.Footer>
                    <a
                      rel="noopener noreferrer"
                      target="_blank"
                      href={filteredRecord.url}
                    >
                      View in Google Maps{" "}
                    </a>
                  </Card.Footer>
                ) : (
                  ""
                )}
              </Card>
            </Popup>
          </Marker>
        ) : (
          ""
        ); // makes marker bounce "n" times
      return newMarker;
    })
  );
}

function mapStateToProps(state) {
  const { filterData } = state.map;
  return {
    filterData,
  };
}
const mapDispatchToProps = {
  setZoomLevel: mapActions.setZoomLevel,
};

export default connect(mapStateToProps, mapDispatchToProps)(MapMarkerComponent);
